import { Box, Button, HStack, LightMode, Text } from '@chakra-ui/react'
import { useState } from 'react'

import { CookieCategory } from '../../gql/graphql'
import { useAppStore } from '../../store/appStore/appStore'
import { Link } from '../Link/Link'
import { showToast } from '../Toast/showToast'

export const CookieDialog = () => {
  const { showCookieConsentDialog, updateUserSettings } = useAppStore(
    ({ userSettings }) => {
      return {
        showCookieConsentDialog: !userSettings.settings?.cookieCategories,
        updateUserSettings: userSettings.updateUserSettings,
      }
    },
  )

  const [isLoading, setIsLoading] = useState(false)
  const handleAcceptCookies = async (categories: CookieCategory[]) => {
    setIsLoading(true)
    await updateUserSettings({
      cookieCategories: categories,
    })
      .then(() => {
        showToast({
          title: 'Cookies accepted',
          description: 'You can change your cookie preferences at any time.',
          variant: 'success',
        })
      })
      .catch(() => {
        showToast({
          title: 'Error',
          description: 'Failed to accept cookies.',
          variant: 'error',
        })
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  if (!showCookieConsentDialog) {
    return null
  }

  return (
    <HStack
      position="absolute"
      bottom={0}
      left={0}
      right={0}
      top="50%"
      px="15px"
      py="15px"
      zIndex={1000}
      backgroundImage="linear-gradient(to bottom, #06232100, #06232180)"
      justifyContent="center"
      alignItems="flex-end"
    >
      <LightMode>
        <Box
          bg="presets.neutral.0"
          borderRadius="16px"
          overflow="hidden"
          maxWidth="800px"
        >
          <Box
            px="20px"
            py="16px"
            borderBottom="1px solid"
            borderColor="presets.neutral.20"
          >
            <Text fontSize="16px" fontWeight="500" color="#062321">
              Cookie Policy
            </Text>
          </Box>
          <Box px="10px" py="18px">
            <Text fontSize="14px" fontWeight="500" lineHeight="normal">
              We use cookies that are necessary to run our website. We use
              analytics cookies to understand website traffic and identify
              opportunities to enhance functionality and the user experience. We
              do not collect or store any personal information. Edit your
              preferences at any time in the{' '}
              <Link to="/settings" color="presets.turquoise.80">
                Settings
              </Link>{' '}
              page.
            </Text>
          </Box>
          <HStack
            px="10px"
            py="14px"
            justifyContent="center"
            gap="40px"
            backgroundColor="presets.neutral.10"
          >
            <Button
              width="190px"
              background="#F69292"
              borderColor="#F69292"
              isLoading={isLoading}
              isDisabled={isLoading}
              _hover={{
                background: '#F69292',
                borderColor: '#F69292',
              }}
              onClick={() => {
                handleAcceptCookies([CookieCategory.Necessary])
              }}
            >
              Necessary Cookies Only
            </Button>
            <Button
              width="190px"
              isLoading={isLoading}
              isDisabled={isLoading}
              onClick={() => {
                handleAcceptCookies([
                  CookieCategory.Necessary,
                  CookieCategory.Analytics,
                ])
              }}
            >
              Accept Cookies
            </Button>
          </HStack>
        </Box>
      </LightMode>
    </HStack>
  )
}
